import { Injectable, inject } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { Observable, map, of, catchError } from 'rxjs';
import { SocialService } from '../application/social.service';
import { AppRoutes } from '@cnp/common';
import { AuthenticationService } from '../application/authentication.service';
import { UserAccessService } from '@cnp/services';

@Injectable({
  providedIn: 'root',
})
export class RouteAccessGuard {
  private _socialService = inject(SocialService);
  private _router = inject(Router);
  private _authService = inject(AuthenticationService);
  private _userAccessService = inject(UserAccessService);


  public canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> {
    // If user is not authenticated, allow access (auth guard handles protection separately)
    if (!this._authService.isLogged) {
      return of(true);
    }

    return this._socialService.getUserInstance().pipe(
      map((userInstance) => {
        const routeKey = route.data?.['routeKey'] as string;

        // Unrestricted types, ungated routes and whitelisted routes pass; a
        // restricted user hitting a disallowed route lands on Not Found.
        if (
          this._userAccessService.canAccessRouteKey(
            userInstance?.type,
            routeKey
          )
        ) {
          return true;
        }

        return this._router.createUrlTree([AppRoutes['NOT_FOUND'].fullPath]);
      }),
      // Fail closed on user instance resolution errors.
      catchError(() =>
        of(
          this._router.createUrlTree([AppRoutes['LOGIN'].fullPath], {
            queryParams: {
              routeUrlToRedirect: state.url,
            },
          })
        )
      )
    );
  }
}
